// extracted by mini-css-extract-plugin
export default {"primary":"BaseButton_primary_mmP2c","primaryReverse":"BaseButton_primaryReverse_XhwUi","label":"BaseButton_label_U_9rc","loader":"BaseButton_loader_mWMlz"};